import * as actionTypes from './actionTypes';
import { summaryService } from './service';
import { SummaryModel } from '@app/src/views/StepThree/publicationConfirmation/models';
import { actionsModalError } from '@app/src/common/modalError';
import { hydrateSummary } from './hydrator';
import { fetchValidate } from '@app/src/common/session';

const fetchSummaryRequest = () => ({
  type: actionTypes.FETCH_SUMMARY_REQUEST
});

const fetchSummaryFailure = () => ({
  type: actionTypes.FETCH_SUMMARY_FAILURE
});

const fetchSummarySuccess = (data: SummaryModel) => ({
  type: actionTypes.FETCH_SUMMARY_SUCCESS,
  data
});

const fetchSummaryWebSuccess = (data) => ({
  type: actionTypes.FETCH_SUMMARY_WEB_SUCCESS,
  data
});

const formatData = (data) => data.data && data.data.length > 0 ? hydrateSummary(data.data[0]) : {};

export const fetchSummary = (categoryId: number, printId: string) => {
  return async dispatch => {
    dispatch(fetchSummaryRequest());
    try {
      const data = await summaryService.get(categoryId, printId);
      if (data.error) {
        dispatch(actionsModalError.openModalError(data.data[0].message, data.data[0].redirect));
      } else {
        dispatch(fetchSummarySuccess(formatData(data)));
      }
    } catch (error) {
      console.log('error action fetchSummary: ', error)
      dispatch(fetchSummaryFailure());
    }
  };
};

export const fetchSummaryConsume = (userId, categoryId: number, printId: string) => {
  return async dispatch => {
    dispatch(fetchSummaryRequest());
    await dispatch(fetchValidate());
    try {
      const data = await summaryService.getConsume(userId, categoryId, printId);
      if (data.error) {
        dispatch(actionsModalError.openModalError(data.data[0].message, data.data[0].redirect));
      } else {
        dispatch(fetchSummarySuccess(formatData(data)));
      }
    } catch (error) {
      console.log(error, 'Error fetchSummaryConsume action')
      dispatch(fetchSummaryFailure());
    }
  };
};

export const fetchSummaryOpportunity = (printId: string) => {
  return async dispatch => {
    dispatch(fetchSummaryRequest());
    try {
      const data = await summaryService.getOpportunity(printId);
      if (data.error) {
        dispatch(actionsModalError.openModalError(data.data[0].message, data.data[0].redirect));
      } else {
        dispatch(fetchSummaryWebSuccess(data.data[0]));
      }
    } catch (error) {
      console.log('error action fetchSummaryOpportunity: ', error)
      dispatch(fetchSummaryFailure());
    }
  };
};
